import type { DispatchFlowConfiguration } from './reducer';

interface Props {
    displayRootFaults: boolean;
    dispatchFlowConfiguration: DispatchFlowConfiguration;
}

const RootFaults = ({ displayRootFaults, dispatchFlowConfiguration }: Props) => {
    return (
        <>
            <h2>Root Faults</h2>
            <label htmlFor="properties-display-rootfaults">
                <input
                    id="properties-display-rootfaults"
                    className="checkbox-margin-left"
                    type="checkbox"
                    checked={displayRootFaults}
                    onChange={({ target }) => {
                        dispatchFlowConfiguration({
                            type: 'updateRootFaultsDisplay',
                            payload: { isDisplayed: target.checked },
                        });
                    }}
                />
                Display root faults when running this Flow
            </label>
        </>
    );
};

export default RootFaults;
